export const COMPANY_NAME = "NOVA WOMEN'S HEALTH";
export const COMPANY_SHORT = "Nova Women's Health";
export const COMPANY_INITIALS = 'NW';
export const COMPANY_ADDRESS_FULL = '3957 LOOMIS PARKWAY, RAVENNA, OH 44266-1804';
export const COMPANY_LOCATION = 'Ravenna, Ohio';
export const COMPANY_REGION = 'Portage County';
export const MAP_URL =
  'https://www.google.com/maps/search/?api=1&query=3957%20LOOMIS%20PARKWAY%2C%20RAVENNA%2C%20OH%2044266-1804';
export const HERO_IMAGE_URL =
  'https://images.unsplash.com/photo-1631815588090-d4bfec5b1ccb?auto=format&fit=crop&w=1600&q=80';

export const PROFILE_FACTS = [
  { label: 'Focus', value: "Women's wellness & care" },
  { label: 'Service Area', value: COMPANY_REGION },
  { label: 'Location', value: COMPANY_LOCATION },
];

export const PUBLIC_INFO = [
  { label: 'Organization', value: COMPANY_NAME },
  { label: 'City / State', value: COMPANY_LOCATION },
  { label: 'Address', value: COMPANY_ADDRESS_FULL },
];

export const CARE_PILLARS = [
  {
    icon: '◐',
    title: 'Compassionate Care',
    body: 'A modern profile centered on dignity, privacy, and patient-first language for every stage of a woman\'s health journey.',
  },
  {
    icon: '✦',
    title: 'Community Focus',
    body: 'Rooted in the Ravenna and broader Portage County community, presented through a calm, editorial public profile.',
  },
  {
    icon: '✿',
    title: 'Modern Wellness',
    body: 'The layout reflects contemporary women\'s health design language — soft palette, generous white space, and serif accents.',
  },
  {
    icon: '❍',
    title: 'Transparent Directory',
    body: 'Address and city are visible for directory and correspondence purposes; private registry identifiers stay off the public page.',
  },
];
